import {Injectable}           from '@angular/core';
import {IGridStatus}          from '../../ap-interface/interfaces/ap-grid-status.interface';
import {ApColumnState}        from '../../ap-interface/enums/ap-column-state.enum';
import {LandUseNames}         from '../../stores/base-data/landuse.store';
import {ApTranslationService} from '../../ap-utils/service/ap-translation.service';
import ILanduse = Data.BaseData.ILanduse;

@Injectable({providedIn: 'root'})
export class LandUseService {
  constructor(private translationService: ApTranslationService) {
  }

  public getLandUseAsStatus(landUseId: number | undefined, landUses: ILanduse[],
                            defaultStatus?: IGridStatus | undefined): IGridStatus {
    const landUse = landUses.find(x => x.Id === landUseId);
    if (!landUse) {
      return defaultStatus ?? {
        state: ApColumnState.Red,
        class: 'ap-status-red',
        description: ''
      };
    }
    switch (landUse.Key) {
      case LandUseNames.Farmland:
        return {
          state: landUse.Id,
          class: 'ap-status-green-autumn-scan',
          description: this.translationService.translate(landUse.Key)
        };
      case LandUseNames.Grassland:
        return {
          state: landUse.Id,
          class: 'ap-status-green-regular-scan',
          description: this.translationService.translate(landUse.Key)
        };
      default:
        return {
          state: landUse.Id,
          class: 'ap-status-grey',
          description: this.translationService.translate(landUse.Key)
        };
    }
  }
}
